import { EnumSchema, FromSchema, ZodDate } from '@40seas/entities/common';
import { z } from 'zod';
import { ChargeStatus } from './charge.status.enum';

export const ChargeStatusDateSchema = z.record(EnumSchema(ChargeStatus), ZodDate);

export class ChargeStatusDateDto extends FromSchema(ChargeStatusDateSchema) {}
